import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // PERF: longer stale window + shared cache cut network chatter dramatically
      // when users bounce between pages. Users won't see fresh data instantly but
      // manual pull-to-refresh (or the query invalidations we already call after
      // mutations) still work.
      staleTime: 5 * 60_000,   // 5 min
      gcTime: 15 * 60_000,     // 15 min
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

registerServiceWorker();
